import React from 'react';
import back from '../../../assets/images/arrows/backward.png';
import Items from '../Items';
import Item from '../Item';
import { getLabelsByLanguage } from "../../../../utilites/util";

interface Props {
    numberOfOrderItems: number;
    activeItem: {
        id: number,
        title: string;
        redirectTo: string;
        url: string;
        cssClass: string;
        items: object[];
    };
    selectedItems: {
        items: object[]
    };
    selectedItemsVisible: boolean;
    isLogin: boolean;
    showMenuItems: (item: any, isLogin: boolean) => {};
    hideSubmenu: () => {};
    links: any[];
    section: string;
}

export const renderMenuList = (links: any[], activeItem: any, showMenuItems: any, section: string, numberOfOrderItems: number) => {
  const elements: any[] = [];

  links.forEach((link: any): void => {
    if (link.id === activeItem.id) {
      elements.push(
        <Item
          key={link.id}
          item={activeItem}
          isLogin={false}
          cssClasses={`no-child list-item first-level ${activeItem.cssClass}`}
          activeItem={activeItem}
        />
      );
      activeItem.items.map((item: any) => {
        elements.push(
          <Item
            key={item.id}
            item={item}
            isLogin={false}
            cssClasses='list-item mobile-second-level'
            handleOnClick={item.items?.length && showMenuItems}
            isRenderImgForward={ !!item.items?.length}
          />
        );
      });
    } else {
      elements.push(
        <div key={link.id} className='p-0 ps-4 mobile-links'>
          <Item
            item={link}
            isLogin={false}
            cssClasses='no-child list-item first-level'
          />
        </div>,
      );
    }
  });

  return elements.map((element) => {
    return element;
  });
};


const MobileList: React.FC<Props> = (props: any) => {
  const {
    activeItem,
    selectedItems,
    hideSubmenu,
    links,
    numberOfOrderItems,
    selectedItemsVisible,
    showMenuItems,
    section
  } = props;

  const labels =  getLabelsByLanguage();
  return (
    <div>
      {
        !selectedItemsVisible ? <div>
          {renderMenuList(links, activeItem, showMenuItems, section, numberOfOrderItems)}
        </div>
          :

          <div id='mobile-menu-items'>
            <div className={'text-start m-4'} onClick={ () => {hideSubmenu(); }}>
              <img src={back} width={19} alt='back' />
              <span className="yettel-link pe-0 ps-2">{labels.back}</span>
            </div>
            <Items
              activeItem={activeItem}
              items={selectedItems.items}
              cssClasses='no-child list-item mobile-third-level'
              isLogin={false}
              isDesktop={false}
            />
          </div>
      }
    </div>
  );
};

export default MobileList;
